module.exports = __webpack_public_path__ + "img/robot-box111.154ab73a.png";